// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__yHmOK","close":"style_close__N2HOn","preventClickArea":"style_preventClickArea__dWwkh","spinnerWrapper":"style_spinnerWrapper__ifPg4"};